import React, { useState } from 'react';
import { Modal, Input, Alert, message, Space } from 'antd';
import { pedirParada } from '../../api/brevoSyncApi';

interface MarcarFallidaModalProps {
  visible: boolean;
  executionId: number | null;
  onClose: () => void;
  onMarked: () => void;
}

const MarcarFallidaModal: React.FC<MarcarFallidaModalProps> = ({ visible, executionId, onClose, onMarked }) => {
  const [motivo, setMotivo] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    if (!executionId || !motivo.trim()) return;
    setSubmitting(true);
    try {
      const { estado } = await pedirParada(executionId, motivo.trim());
      message.success(estado === 'error' ? 'Ejecución cerrada' : 'Parada pedida: el motor la atenderá entre lotes');
      setMotivo('');
      onMarked();
      onClose();
    } catch (error: any) {
      if (error?.response?.status === 404) {
        message.error('La ejecución no existe o ya no está en curso');
      } else {
        message.error('Error al pedir la parada');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setMotivo('');
    onClose();
  };

  return (
    <Modal
      open={visible}
      title="Parar la ejecución"
      okText="Pedir la parada"
      cancelText="Cancelar"
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={submitting}
      okType="default"
      okButtonProps={{ danger: true, disabled: !motivo.trim() }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Alert
          type="warning"
          showIcon
          message="El motor se parará entre dos lotes"
          description="Si la ejecución aún no había empezado, o el motor no da señales desde hace más de 10 minutos, se cierra en error al momento y se puede lanzar otra."
        />
        <Input.TextArea
          value={motivo}
          onChange={e => setMotivo(e.target.value)}
          placeholder="Motivo, ej: sin progreso desde hace 15 min"
          rows={3}
        />
      </Space>
    </Modal>
  );
};

export default MarcarFallidaModal;
